<template>
  <div class="mypage-point-expiration-date-table-section">
    <table class="mypage-point-expiration-date-table-section__table">
      <thead>
        <tr>
          <th>{{ $tc('MypagePage.MypagePointExpirationDatePage.point') }}</th>
          <th>{{ $tc('MypagePage.MypagePointExpirationDatePage.expirationDate') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="[expirationDate, userPointWithGrantedSeasonYear] in expirationUserPointList"
          :key="expirationDate"
        >
          <td class="mypage-point-expiration-date-table-section__point">
            <span class="mypage-point-expiration-date-table-section__point-data">{{
              userPointWithGrantedSeasonYear.point.toLocaleString()
            }}</span>
            <span class="mypage-point-expiration-date-table-section__point-unit">P</span>
          </td>
          <td class="mypage-point-expiration-date-table-section__date">
            {{ expirationDate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { UserPointWithGrantedSeasonYearType } from '@/store/hook/useUserPoint'

export default defineComponent({
  name: 'MypagePointExpirationDateTableSection',
  props: {
    /**
     * 永久ポイントを除いた、ポイントと失効日の一覧
     */
    userPointsWithExpirationByExpirationDate: {
      type: Map as PropType<Map<string, UserPointWithGrantedSeasonYearType>>,
      default: () => ({}),
    },
  },
  setup(props) {
    const expirationUserPointList = computed(() =>
      props.userPointsWithExpirationByExpirationDate.entries(),
    )
    return {
      expirationUserPointList,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-point-expiration-date-table-section {
  &__table {
    width: 100%;

    tr {
      border-bottom: 1px solid $black10;
    }

    th {
      padding-bottom: 12px;
      font-size: 11px;
      font-weight: 500;
      color: $black20;

      @media screen and (min-width: $responsiveTabletWidth) {
        color: $gray50;
      }
    }

    td {
      padding: 12px 0;
    }
  }

  &__point {
    width: 65%;
    font-weight: 500;
    color: $black80;
    letter-spacing: 0.04em;

    @media screen and (min-width: $responsiveTabletWidth) {
      width: calc(100% - 120px);
    }

    &-data {
      font-size: 13px;
    }

    &-unit {
      font-size: 10px;
    }
  }

  &__date {
    width: 35%;
    font-size: 11px;
    font-weight: 500;
    color: $black20;

    @media screen and (min-width: $responsiveTabletWidth) {
      width: 120px;
    }
  }
}
</style>
